@if(loading$ | async){
    <app-loader></app-loader>
}
<section class="my-matches">
    <section class="main">
        <div class="top">
            <h3 i18n="Title for My Matches section@@MY_MATCHES"><span class="regular">My</span> Matches</h3>

            <div class="actions">
                <div class="actions-icon-container">
                  <button type="button" class="notifications-btn" [routerLink]="['notifications']" (click)="showNotifications()">
                    <img src="assets/icons/icon_notification.svg" alt="">

                    @if(partialNotifications !== 0){
                      <div class="notification-badge">{{partialNotifications}}</div>
                    }
                  </button>
                </div>
            </div>    
        </div>
        
        <div class="content">
            <div class="matches">
                <h4 i18n="Title for the matches list in My Matches section@@MY_MATCHES">My matches</h4>
                <div class="profiles">
                  @if(matchesLoading){
                    <app-loader></app-loader>
                  } @else {
                    @for(m of matches; track m.id){
                      <app-match [profile]="m"></app-match> 
                    } @empty {
                      <ng-container i18n="Text for when no matches to display in the matches list in My Matches section@@NO_MATCHES">No match</ng-container> 
                    }
                  }
                </div>
            </div>
            
            <div class="conversations">
                <h4 i18n="Title for the conversations list in My Matches section@@MY_CONVERSATIONS">My conversations</h4>
                <div class="content">
                  <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </section>
</section>
